<form class="app-flex-form" (keydown)="(null)">
  @for (filter of filters(); track $index) {
    @if (currentFilterView() === filter.label && filter.column === agentProfileFilterKey.Type) {
      <mat-selection-list [formField]="formTree.type">
        @for (type of agentTypeValues; track $index) {
          <mat-list-option [value]="type" (click)="$event.stopPropagation()">
            {{ type | titlecase }}
          </mat-list-option>
        }
      </mat-selection-list>
    }
    @if (currentFilterView() === filter.label && filter.column === agentProfileFilterKey.Region) {
      <mat-selection-list [formField]="formTree.region" class="max-h-80 overflow-y-auto">
        @for (region of availableRegions; track region.code) {
          <mat-list-option [value]="region.code" (click)="$event.stopPropagation()">
            {{ region.name }}
          </mat-list-option>
        }
      </mat-selection-list>
    }
  }
</form>
